module.exports = __webpack_public_path__ + "media/frontend/assets/icons/icon-tile-distribution-4a59523b6c589569625a842f3a36bf4d.png";